import {Injectable} from '@angular/core';
import {Action, State, StateContext} from '@ngxs/store';
import {FetchPageLength} from '../actions/paginator.actions';

@State<number[]>({
  name: 'paginator',
  defaults: []
})

@Injectable({
  providedIn: 'root'
})
export class PaginatorState {
  @Action(FetchPageLength)
  getPageLength(ctx: StateContext<number>, {payload}: FetchPageLength): void {
    ctx.setState(payload);
  }
}
